'use strict';

document.addEventListener('DOMContentLoaded', () => {
    let $routePlanner = document.querySelector('.RoutePlanner');

    if (!$routePlanner) {
        return;
    }

    let now = new Date();

    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    now.setSeconds(0);
    now.setMilliseconds(0);

    document.getElementById('f-timetable-time').valueAsDate = now;
    document.getElementById('f-timetable-date').valueAsDate = now;

    document.getElementById('f-timetable-date').addEventListener('input', (event) => {
        let date = event.target.valueAsDate,
            dd = date.getDate().toString().padStart(2, '0'),
            mm = (date.getMonth() + 1).toString().padStart(2, '0'),
            yy = date.getFullYear().toString().slice(-2);

        event.target.closest('form').querySelector('[name="date"]').value = dd + '.' + mm + '.' + yy;
    });
    document.getElementById('f-timetable-date').dispatchEvent(new Event('input', {bubbles: true}));

    $routePlanner.querySelectorAll('form').forEach(($form) => {
        $form.querySelector('[name="language"]').value = document.documentElement.lang.replace('-', '_');

        $form.addEventListener('submit', () => {
            $form.querySelectorAll('.js-suggestions').forEach(($element) => {
                let $shadow = $element.closest('form').querySelector('[name="' + $element.dataset.shadow + '"]');

                if ($shadow.value === '') {
                    if ($element.hasAttribute('name')) {
                        $shadow.disabled = true;

                        if ($element.value === '') {
                            $element.disabled = true;
                        }
                    } else {
                        $shadow.value = $element.value;
                    }
                } else {
                    $element.disabled = true;
                }
            });
        });
    });

    document.querySelectorAll('.js-suggestions').forEach(($element) => {
        let refineId = '',
            autoCompleteInstance = new autoComplete({
                selector: '#' + $element.id,
                data: {
                    src: async (query) => {
                        let url = '?routeplanner/suggestions',
                            body = {
                                term: query,
                                context: $element.closest('form').querySelector('[name="context"]').value,
                            };

                        $element.closest('form').querySelector('[name="' + $element.dataset.shadow + '"]').value = '';

                        try {
                            if (refineId) {
                                url += '/refine';
                                body.id = refineId;

                                refineId = ''; // Reset refineId
                            } else {
                                body.type = $element.dataset.type;
                            }

                            const source = await fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(body),
                            });

                            return await source.json();
                        } catch (error) {
                            return error;
                        }
                    },
                    keys: ['label'],
                    cache: false,
                    filter: function() {
                        let results = [];

                        this.store.forEach((item) => {
                            results.push({
                                key: 'label',
                                match: item.label,
                                value: item,
                            });
                        });

                        return results;
                    },
                },
                resultsList: {
                    element: (list, data) => {
                        if (!data.results.length) {
                            const message = document.createElement('div');

                            message.setAttribute('class', 'no-result');

                            list.prepend(message);
                        }
                    },
                    maxResults: undefined,
                    noResults: true,
                },
                resultItem: {
                    highlight: true,
                    element: (item, data) => {
                        item.classList.add('type--' + (data.value.type === 1 ? 'location' : 'stop'));

                        if (data.value.refine) {
                            item.classList.add('is-refinable');
                        }
                    },
                },
                debounce: 250,
                searchEngine: 'loose',
                threshold: 1,
            });

        $element.addEventListener('selection', async (event) => {
            refineId = '';

            if (event.detail.selection.value.refine) {
                refineId = event.detail.selection.value.refine;

                autoCompleteInstance.start();
            } else {
                $element.closest('form').querySelector('[name="' + $element.dataset.shadow + '"]').value = event.detail.selection.value.id;
                $element.value = event.detail.selection.value.rawValue;
            }
        });

    });
});
